import { RelatedLP } from '../RelatedPages';
export default function Page() { return <RelatedLP slug="butler-academy" locale="ja" />; }
